import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  connect() {
    import('lexxy-stylesheets/lexxy-content.css').catch((error) => {
      this.application.handleError(error, 'Failed to load Lexxy content styles', { identifier: this.identifier })
    })
  }
}
